import { ChallengePrizeType } from './ChallengePrize';

export const CHALLENGE_PRIZES: ChallengePrizeType[] = [
    {
        text: '250 000 рублей',
        image: 'https://avatars.mds.yandex.net/get-lpc/14837328/c24898a1-e6df-48ef-8ff3-392722f2d8cd/width_1280_q90',
    },
    {
        text: '150 000 рублей',
        image: 'https://avatars.mds.yandex.net/get-lpc/16904900/e0f1c9a4-1721-47d6-8f0b-484ba79a2e14/width_1280_q90',
    },
    {
        text: '50 000 рублей\nи Яндекс Станция',
        image: 'https://avatars.mds.yandex.net/get-lpc/16904900/90fb2f00-d166-455b-96f8-8d7849071a6f/width_1280_q90',
    },
];
